import { Injectable } from '@angular/core';
import { AwsApiService } from './aws-api.service';
import { LogService } from './log.service';
import { RouterService } from './router.service';
import { Organization } from '../types/organization';
import { HttpClient } from '@angular/common/http';
import { IWorkflow } from '../interfaces/IWorkflow';
import { environment } from '../../environments/environment';
import { Workflow } from '../types/workflow';

@Injectable({
  providedIn: 'root'
})
export class ForgotUsernameService {
  private email: string;
  private organization: Organization;
  private workflow: Workflow;

  constructor(
    private api: AwsApiService,
    private log: LogService,
    private router: RouterService,
    private http: HttpClient
  ) {
    this.workflow = new Workflow('ForgotUsername', log);
  }

  isInProgress(): boolean {
    return this.workflow.isInProgress();
  }

  reset() {
    this.workflow.end();
    this.email = null;
    this.organization = null;
  }

  forgotUsername(email: string, onError: Function) {
    this.email = email;
    this.workflow.start();

    const url = environment.api.recoverUsername;
    const body = { email: this.email };
    this.log.trace('posting to ' + url, body);

    return this.http.post(url, body).subscribe(
      data => {
        this.log.trace('response', data);
        this.router.gotoForgotUsernameSuccess();
      },
      err => {
        this.log.error(err);
        this.reset();
        onError(err);
      }
    );
  }
}
